import React from "react";
import { Navigate } from "react-router-dom";
import {
  adminInfoGetterService,
  permissionsGetterService,
} from "../../shared/services";
import { hasPermission } from "../../shared/permissionUtils";
import options from "../../features/side-bar/options";

// Helper function to find route by slug (name)
const findRouteBySlug = (routes, slug) => {
  for (const route of routes) {
    if (route.name === slug) {
      return route;
    }
    // Check in children
    if (route.children && route.children.length > 0) {
      const found = findRouteBySlug(route.children, slug);
      if (found) return found;
    }
  }
  return null;
};

const PrivateRoute = ({ children, slug }) => {
  const token = adminInfoGetterService(); // Get the authentication token
  const userPermissions = permissionsGetterService(); // Get user permissions

  // Find the matching route in the options
  const route = findRouteBySlug(options, slug);

  // Check if user has permission to access this route
  const hasAccess = route && hasPermission(userPermissions, route.permission);

  // If the user has a token and has permission, render the route
  return token && hasAccess ? children : <Navigate to="/" />;
};

export default PrivateRoute;
